module.exports = __webpack_public_path__ + "static/media/14_3.ffadbd17.png";